import React from 'react';
import { motion } from 'framer-motion';
export function ValueSection() {
  return <section className="py-20 md:py-24 bg-brand-offWhite" data-id="element-252">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-253">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-254">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-black mb-8" data-id="element-255">
            You Deserve a Property That Reflects How Much You Care
          </h2>

          <div className="space-y-6 text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto" data-id="element-256">
            <p data-id="element-257">
              You work hard. You've invested in your home. And you deserve a
              yard and property that shows it.
            </p>
            <p data-id="element-258">
              At EITHAN Landscaping & Junk Removal, we believe your outdoor
              space should bring you joy — not stress. That's why we show up on
              time, do the job right, and treat every property like it's our
              own.
            </p>
            <p data-id="element-259">We're not just a lawn crew.</p>
            <p className="font-semibold text-brand-gold text-xl pt-2" data-id="element-260">
              We're your dedicated property care partner — serving homeowners
              just like you across Chattanooga and beyond.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}